<template>
    <v-card flat>
        <v-container>
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels class="mb-1">
                        <v-expansion-panel>
                            <v-expansion-panel-header>送信通知</v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-simple-table height="200" dense>
                                    <tbody>
                                        <tr v-for="history in histories" :key="history.notificationID" @click="onClickHistory(history)">
                                            <td>
                                                {{history.content.title}}
                                            </td>
                                            <td>
                                                {{history.dateTime}}
                                            </td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                                <v-btn color="primary" @click="onClickMore">MORE</v-btn>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
                <v-col cols="12">
                    <v-expansion-panels class="mb-1">
                        <v-expansion-panel>
                            <v-expansion-panel-header>宛先 - {{getToType(toType).name}}</v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-container fluid class="pa-0">
                                    <v-row>
                                        <v-col>                                            
                                            <v-select
                                                v-model="toType"
                                                label="宛先"
                                                :items="toTypes"
                                                item-text="name"
                                                item-value="type"
                                                hide-details
                                                outlined
                                                dense />
                                        </v-col>
                                    </v-row>
                                    <v-row v-if="toType=='user'">
                                        <v-col>
                                            <v-text-field
                                                v-model="toUserUID"
                                                label="ユーザーUID"
                                                outlined
                                                hide-details
                                                clearable
                                                append-icon="mdi-plus-circle-outline"
                                                @click:append="onClickAddUser" />
                                        </v-col>
                                        <v-col>
                                            <v-select
                                                v-model="toUserUIDList"
                                                label="ユーザー"
                                                chips
                                                small-chips
                                                deletable-chips
                                                :items="toUserUIDList"
                                                multiple
                                                hide-details
                                                outlined />
                                        </v-col>
                                    </v-row>
                                    <v-row v-if="toType=='license'">
                                        <v-col>
                                            <v-text-field
                                                v-model="toLicenseCode"
                                                label="ライセンスコード"
                                                outlined
                                                hide-details
                                                clearable />
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
                <v-col cols="12">
                    <v-container fluid>
                        <v-row dense>
                            <v-col>
                                <v-select 
                                    v-model="notification.type" 
                                    label="種類" 
                                    hide-details 
                                    outlined
                                    dense 
                                    :items="notification.notificationTypes" 
                                    item-text="name" 
                                    item-value="type"/>
                                </v-col>
                            <v-col>
                                <v-text-field 
                                    v-model="notification.title" 
                                    clearable
                                    hide-details 
                                    dense 
                                    label="タイトル" 
                                    outlined 
                                    type="text" 
                                    counter="20" />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col>
                                <!-- <v-textarea
                                    v-model="notification.message"
                                    label="通知"
                                    rows="4"
                                    outlined
                                    clearable
                                    hide-details 
                                    auto-grow>
                                </v-textarea> -->
                                <quillEditor
                                    ref="editor"
                                    v-model="notification.message"
                                    :options="editorOptions"                                
                                    />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col>
                                プレビュー:
                                <div class="body-2 mb-1" v-html="notification.message.replace(/\r?\n/g, '<br>')" />
                            </v-col>
                        </v-row>
                    </v-container>
                    <v-card-actions>
                        <v-btn color="primary" @click="onClickSendNotification">通知する</v-btn>
                    </v-card-actions>
                </v-col>
            </v-row>
        </v-container>
        <Confirm ref="confirm" />
    </v-card>
</template>

<script>
    Date.prototype.toFormatString = function (format) {
        const year = this.getFullYear()
        const month = this.getMonth() + 1
        const month2 = ("0" + month).slice(-2)
        const day2 = ("0" + this.getDate()).slice(-2)
        const hour2 = ("0" + this.getHours()).slice(-2)
        const minute2 = ("0" + this.getMinutes()).slice(-2)
        const second2 = ("0" + this.getSeconds()).slice(-2)

        const formattedValue = format.replace("yyyy", year).replace("MM", month2).replace("dd", day2).replace("HH", hour2).replace("mm", minute2).replace("ss", second2)

        return formattedValue
    }

    import Confirm from '@/components/tools/ConfirmDialog';
    import db from '@/firebase/firestore.js'
    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css'
    import 'quill/dist/quill.bubble.css'
    import { quillEditor } from 'vue-quill-editor'

    export default {
        components: {
            Confirm,
            quillEditor,
        },
        data: function() {
            return {
                toTypes: [
                    {name: "全ユーザー", type: "all_users"},
                    {name: "特定ユーザー", type: "user"},
                    {name: "特定ライセンス所有者(未実装)", type: "license"},
                ],
                toType: "all_users",
                toUserUID: "",
                toUserUIDList: [],
                toLicenseCode: "",
                histories: [],
                notification: {
                    notificationTypes: [
                        {type:1, name:"情報"}
                    ],
                    type: 1,
                    title: "",
                    message: ""
                },
                /** エディターのオプション */
                editorOptions: {
                    theme: "snow",
                    placeholder: "ここに通知を入力",
                    readOnly: false
                }
            }
        },
        /**
         * 
         */
        created: function () {
            this.histories = []
            const currentDateTime = new Date()
            this.addHistories(currentDateTime.toFormatString("yyyy-MM-dd HH:mm:ss"))
        },
        methods: {
            /**
             * MOREボタン押下時
             */
            onClickMore: function () {
                this.addHistories(this.histories[this.histories.length-1].dateTime)
            },
            /**
             * ユーザーUID追加アイコン押下時
             */
            onClickAddUser: function () {                
                if (this.toUserUID == null || this.toUserUID.length == 0 || this.toUserUIDList.find((v)=>v == this.toUserUID) != null) {
                    return
                }
                this.toUserUIDList.push(this.toUserUID)
                this.toUserUID = null
            },
            /**
             * 履歴の通知押下時
             */
            onClickHistory: function (history) {
                this.notification.title = history.content.title
                this.notification.message = history.content.message
            },
            /**
             * 通知送信ボタン押下時
             */
            onClickSendNotification: function () {
                const self = this

                this.$refs.confirm.show({
                    title: "通知の送信",
                    message: "通知を送信しますか？",
                    width: 400,
                    buttonYes: "送信する",
                    buttonNo: "送信しない",
                    listenerYes: function () {
                        sender()
                        return true
                    }
                })

                const sender = function () {
                    // const userUID = this.$store.getters["userUID"]
                    // const userData = this.$store.getters["userData"]
                    // var avaterURL = null
                    // if (userData.avaterImage != null){
                    //     avaterURL = userData.avaterImage.url
                    // }
                    const id = self.df_currentDateTime("yyyyMMddHHmmss")
                    const notification = {
                        version: "1.0.0",
                        notificationID: id,
                        dateTime: self.df_currentDateTime(),
                        sender: null,
                        content: {
                            type: self.notification.type,
                            title: self.notification.title,
                            message: self.notification.message,
                            text: self.$refs.editor.quill.getText()
                        },
                        data: null,
                        openedDateTime: ""
                    }
                    
                    db.collection("system_notifications").doc(id).set(notification).then(function(){
                        console.log("通知成功")
                        self.notification.type = 1
                        self.notification.title = ""
                        self.notification.message = ""
                    }).catch (function(error){
                        console.log(error)
                    })

                    self.histories.splice(0, 0, notification)   // 履歴に追加

                    switch (self.toType) {
                        case "all_users":
                            db.collection("users").get().then(function(refUsers){
                                refUsers.forEach(function(docUser){
                                    var sentNum = 0
                                    const user = docUser.data()
                                    db.collection("users").doc(user.userUID).collection("notifications").doc(id).set(notification).then(function(){
                                        sentNum++
                                        if (sentNum == refUsers.size) {
                                            console.log("通知成功", sentNum+"通")
                                            self.$store.commit("notification", {message:"通知送信終了", isError:false})
                                        }
                                    })
                                })
                            })
                            break;
                        case "user":
                            var sentNum = 0
                            self.toUserUIDList.forEach(function(userUID) {
                                db.collection("users").doc(userUID).collection("notifications").doc(id).set(notification).then(function(){
                                    sentNum++
                                    if (sentNum == self.toUserUIDList.length) {
                                        console.log("通知成功", sentNum+"通")
                                        self.$store.commit("notification", {message:"通知送信終了", isError:false})
                                    }
                                })
                            })
                            break;
                    }
                }
            },
            /**
             * 指定された日時以前の通知を配列に格納
             */
            addHistories: function (dateTime) {
                console.log("addHistories", dateTime)
                const self = this
                db.collection("system_notifications").where("dateTime", "<", dateTime).orderBy("dateTime", "desc").limit(10).get().then(function(snapShot){
                    snapShot.forEach(function(doc){
                        self.histories.push(doc.data())
                    })
                })
            },
            /**
             * 指定された宛先タイプの宛先を返す
             */
            getToType: function (type) {
                const toType = this.toTypes.find((v)=>v.type == type)
                if (toType == null) return {name:"???"}
                return toType
            }
        }
    }
</script>